var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"sidebar"},[_c('PatchSidebar')],1),_c('div',{staticClass:"page__content"},[_vm._t("canvas"),_c('JacketViewSwitcher')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }